import LatLngBounds = google.maps.LatLngBounds;
import LatLng = google.maps.LatLng;

import {Coordinate} from "@luminate/luminate-ts-sdk";

export const CoordinatesToLatLngBoundsConverter = (source: Array<Coordinate>): LatLngBounds => {
    const bounds = new LatLngBounds();
    source.forEach(coordinate => bounds.extend(new LatLng(coordinate.latitude, coordinate.longitude)));
    return bounds;
};